var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E6F0FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0749 25.65C20.3249 25.65 20.5374 25.5667 20.7124 25.4C20.8874 25.2333 20.9749 25.0167 20.9749 24.75V20.375C20.9749 20.1417 20.8874 19.9375 20.7124 19.7625C20.5374 19.5875 20.3249 19.5 20.0749 19.5C19.8249 19.5 19.6124 19.5875 19.4374 19.7625C19.2624 19.9375 19.1749 20.15 19.1749 20.4V24.775C19.1749 25.025 19.2624 25.2333 19.4374 25.4C19.6124 25.5667 19.8249 25.65 20.0749 25.65ZM19.9999 17.85C20.2999 17.85 20.5457 17.7583 20.7374 17.575C20.9291 17.3917 21.0249 17.15 21.0249 16.85C21.0249 16.55 20.9291 16.3 20.7374 16.1C20.5457 15.9 20.2999 15.8 19.9999 15.8C19.6999 15.8 19.4541 15.9 19.2624 16.1C19.0707 16.3 18.9749 16.55 18.9749 16.85C18.9749 17.15 19.0707 17.3917 19.2624 17.575C19.4541 17.7583 19.6999 17.85 19.9999 17.85ZM19.9999 30.85C18.5332 30.85 17.1707 30.5875 15.9124 30.0625C14.6541 29.5375 13.5582 28.8083 12.6249 27.875C11.6916 26.9417 10.9624 25.8458 10.4374 24.5875C9.9124 23.3292 9.6499 21.9667 9.6499 20.5C9.6499 19.05 9.9124 17.6917 10.4374 16.425C10.9624 15.1583 11.6916 14.0625 12.6249 13.1375C13.5582 12.2125 14.6541 11.4792 15.9124 10.9375C17.1707 10.3958 18.5332 10.125 19.9999 10.125C21.4499 10.125 22.8082 10.3958 24.0749 10.9375C25.3416 11.4792 26.4374 12.2125 27.3624 13.1375C28.2874 14.0625 29.0207 15.1542 29.5624 16.4125C30.1041 17.6708 30.3749 19.0333 30.3749 20.5C30.3749 21.9667 30.1041 23.3292 29.5624 24.5875C29.0207 25.8458 28.2874 26.9417 27.3624 27.875C26.4374 28.8083 25.3416 29.5375 24.0749 30.0625C22.8082 30.5875 21.4499 30.85 19.9999 30.85Z",
    fill: "#0565D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.b1c7239b37e0c8617514c2e6fb7251ac.svg";
export { ForwardRef as ReactComponent };